import { byWindowAction, sendGoogleEvent, debounce } from '@html/_common/utils';

const EVENT_CATEGORY = 'CLP - ';

export default function AOClpSliderWithMedia() {
  const carousels = [];
  let $body = null;
  let bodyWidth = 0;

  const checkArrowVisibility = (carousel) => {
    if (carousel.currentIndex === carousel.shown || carousel.currentIndex === 1) {
      carousel.$arrowPrevious.toggleClass(carousel.arrowVisibilityClass, false);
    } else {
      carousel.$arrowPrevious.toggleClass(carousel.arrowVisibilityClass, true);
    }

    // Show next arrow if we haven't reached the end
    // The end is when currentIndex + shown >= size, meaning we can see the last element
    if (carousel.currentIndex + carousel.shown > carousel.size) {
      carousel.$arrowNext.toggleClass(carousel.arrowVisibilityClass, false);
    } else {
      carousel.$arrowNext.toggleClass(carousel.arrowVisibilityClass, true);
    }
  };

  const smoothScroll = (carousel, to, duration) => {
    if (carousel.timeoutId) clearTimeout(carousel.timeoutId);

    if (duration < 0) return;

    const difference = to - carousel.$carouselElement.scrollLeft();
    const perTick = (difference / duration) * 10;

    carousel.timeoutId = setTimeout(() => {
      // eslint-disable-next-line
      if (!isNaN(parseInt(perTick, 10))) {
        carousel.$carouselElement.scrollLeft(carousel.$carouselElement.scrollLeft() + perTick);

        smoothScroll(carousel, to, duration - 10);
      }
    }, 10);
  };

  const moveCarousel = (carousel) => {
    let scrollLeft = 0;

    // Check if we're trying to show the last group of items
    if (carousel.currentIndex + carousel.shown > carousel.size) {
      // For the last position, we want to scroll just enough to show the last element completely
      // This should be: total content width - container width
      const { scrollWidth: totalScrollWidth, clientWidth } = carousel.$carouselElement[0];
      scrollLeft = Math.max(0, totalScrollWidth - clientWidth);
    } else {
      // Normal positioning
      scrollLeft = (carousel.currentIndex - carousel.shown)
                * (carousel.elementWidth + carousel.elementMarginRight)
                + (2 * carousel.elementMarginLeft);
    }

    smoothScroll(carousel, scrollLeft, 300);
  };

  const onClickArrow = (event) => {
    const $element = $(event.currentTarget);
    const shift = $element.data('shift');
    const carouselId = $element.data('carouselId');
    const carousel = carousels[carouselId];

    // Check bounds: for next arrow, ensure we don't scroll past the last element
    // For previous arrow, ensure we don't go below the first position
    if ((shift < 0 && carousel.currentIndex > 1)
        || (shift > 0 && carousel.currentIndex + carousel.shown <= carousel.size)) {
      carousel.currentIndex += shift;

      moveCarousel(carousel);

      checkArrowVisibility(carousel);
    }

    sendGoogleEvent(`${EVENT_CATEGORY}Slider With Media`, 'Change', shift > 0 ? 'Next' : 'Previous');
  };

  const calculateShown = (carousel) => {
    const carouselWidth = carousel.$carouselElement.width() - parseInt(carousel.$carouselElement.css('margin-right'), 10) - parseInt(carousel.$carouselElement.css('margin-left'), 10);

    // Calculate how many items can fit, accounting for margins between elements
    // Each element takes up: elementWidth + marginRight (except the last one)
    // So we need to account for (n-1) margins for n elements
    const elementWithMargin = carousel.elementWidth + carousel.elementMarginRight;
    const newShown = Math.floor((carouselWidth + carousel.elementMarginRight) / elementWithMargin);

    if (!carousel.currentIndex) {
      carousel.currentIndex = newShown;
    }

    carousel.shown = newShown;

    // Fix arrow visibility - don't show next arrow if we can see all items
    if (carousel.size <= carousel.shown) {
      carousel.$arrowNext.toggleClass(carousel.arrowVisibilityClass, false);
    }
  };

  const calculateElementDimensions = (carousel) => {
    carousel.elementWidth = carousel.$firstListElement.width();
    carousel.elementMarginRight = parseFloat(carousel.$firstListElement.css('margin-right'));
    carousel.elementMarginLeft = parseFloat(carousel.$firstListElement.css('margin-left'));
  };

  const initiateCarousel = (index, element) => {
    const $containerElement = $(element);
    const $carouselElement = $containerElement.find('.js-ao-clp-slider-with-media__gallery-list');
    const $listElements = $carouselElement.find('.js-ao-clp-slider-with-media__image');

    if (!$listElements.length) return;

    $listElements.click((event) => {
      const isVideo = !!$(event.currentTarget).find('.js-ao-clp-youtube-video').length;
      const eventValue = isVideo ? 'Video' : 'Image';

      sendGoogleEvent(`${EVENT_CATEGORY}Slider With Media`, 'Open', eventValue);
    });

    const $firstListElement = $($listElements[0]);
    const carouselId = carousels.length;
    const carousel = {};

    carousel.arrowVisibilityClass = 'ao-clp-slider-with-media__scroll-arrow--visible';
    carousel.$carouselElement = $carouselElement;
    carousel.$firstListElement = $firstListElement;
    carousel.shown = 1;
    carousel.size = $listElements.length;
    carousel.$arrowPrevious = $containerElement.find('.js-ao-clp-slider-with-media__scroll-control--left');
    carousel.$arrowNext = $containerElement.find('.js-ao-clp-slider-with-media__scroll-control--right');

    calculateElementDimensions(carousel);

    calculateShown(carousel);

    carousel.$arrowNext.data('carouselId', carouselId);

    carousel.$arrowNext.click(onClickArrow);

    carousel.$arrowPrevious.data('carouselId', carouselId);
    carousel.$arrowPrevious.click(onClickArrow);

    carousels.push(carousel);

    checkArrowVisibility(carousel);
  };

  const onResize = debounce(() => {
    const newBodyWidth = $body.width();

    if (newBodyWidth !== bodyWidth) {
      for (let i = 0; i < carousels.length; i += 1) {
        const carousel = carousels[i];

        calculateElementDimensions(carousel);
        calculateShown(carousel);
        moveCarousel(carousel);
        checkArrowVisibility(carousel);
      }
    }
  }, 250);

  const initiate = () => {
    const $carouselLists = $('.js-ao-clp-slider-with-media__slider');

    if ($carouselLists.length > 0) {
      $carouselLists.each(initiateCarousel);

      $body = $('body');
      bodyWidth = $body.width();

      byWindowAction(['resize'], onResize);
    }
  };

  return { initiate };
}
